module.exports = __webpack_public_path__ + "static/media/logo-black-dada.543868d0.svg";